// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON = "K\u00fapi\u0165";
export const BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON_NOTE = "Pomocou tla\u010didla \"K\u00fapi\u0165\" m\u00f4\u017ee\u0161 vyu\u017ei\u0165 zv\u00fdhodnen\u00fa dopravu, tovar si ihne\u010f rezervuje\u0161 a nikto \u0165a nepredbehne";
export const BAZAAR_PRODUCT_IS_RESERVED = "Tento tovar je rezervovan\u00fd.|Z\u00e1ujemca vyu\u017eil zv\u00fdhodnen\u00fa dopravu.";
export const BZ2_JUST_SEND_MESSAGE = "Po\u0161li spr\u00e1vu";
export const BZ2_SEND_MESSAGE_ANONYMOUS = "Po\u0161li spr\u00e1vu predajcovi";
